"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_intl_1 = require("react-intl");
var messages = (0, react_intl_1.defineMessages)({
    dashboard: {
        id: 'menu.dashboard',
        defaultMessage: 'Home',
        description: 'Dashboard',
    },
    notifications: {
        id: 'menu.notifications',
        defaultMessage: 'Notifications',
        description: 'Notifications',
    },
    map: {
        id: 'menu.map',
        defaultMessage: 'Map',
        description: 'Map',
    },
    taskDoc: {
        id: 'menu.taskDoc',
        defaultMessage: 'Task doc',
        description: 'Task doc',
    },
    fields: {
        id: 'menu.fields',
        defaultMessage: 'Fields',
        description: 'Fields',
    },
    machineAndImplements: {
        id: 'menu.machineAndImplements',
        defaultMessage: 'Machine & implements',
        description: 'Machine & implements',
    },
    team: {
        id: 'menu.team',
        defaultMessage: 'Team',
        description: 'Team',
    },
    myFleet: {
        id: 'menu.myFleet',
        defaultMessage: 'Fleet',
        description: 'Fleet',
    },
    settings: {
        id: 'menu.settings',
        defaultMessage: 'Settings',
        description: 'Settings',
    },
    profile: {
        id: 'menu.profile',
        defaultMessage: 'Profile',
        description: 'Profile',
    },
    dataAndPrivacy: {
        id: 'menu.dataAndPrivacy',
        defaultMessage: 'Data and privacy',
        description: 'Data and privacy',
    },
    devices: {
        id: 'menu.devices',
        defaultMessage: 'Devices',
        description: 'Devices',
    },
    logout: {
        id: 'menu.logout',
        defaultMessage: 'Log out',
        description: 'Log out',
    },
    serviceAndInformation: {
        id: 'menu.serviceAndInformation',
        defaultMessage: 'Service & Information',
        description: 'Service & Information',
    },
    fleetOverview: {
        id: 'menu.fleetOverview',
        defaultMessage: 'Fleet Overview',
        description: 'Fleet Overview',
    },
    manuals: {
        id: 'menu.manuals',
        defaultMessage: 'Manuals',
        description: 'Manuals',
    },
    warranty: {
        id: 'menu.warranty',
        defaultMessage: 'Warranty',
        description: 'Warranty',
    },
    recalls: {
        id: 'menu.recalls',
        defaultMessage: 'Recalls',
        description: 'Product Support Programs (PSPs)',
    },
    psp: {
        id: 'menu.psp',
        defaultMessage: 'Product Support Programs (PSPs)',
        description: 'Product Support Programs',
    },
    dealerLocator: {
        id: 'menu.dealerLocator',
        defaultMessage: 'Dealer Locator',
        description: 'Dealer locator',
    },
    diagnosticTroubleCodes: {
        id: 'menu.diagnosticTroubleCodes',
        defaultMessage: 'Diagnostic Trouble Codes',
        description: 'Diagnostic Trouble Codes',
    },
    contactUs: {
        id: 'menu.contactUs',
        defaultMessage: 'Contact Us',
        description: 'Contact us',
    },
    businessAccounts: {
        id: 'menu.businessAccounts',
        defaultMessage: 'Business Information',
        description: 'Business Accounts',
    },
    smartFarming: {
        id: 'menu.smartFarming',
        defaultMessage: 'Smart Farming',
        description: 'Smart Farming',
    },
    logInAndSecurity: {
        id: 'menu.logInAndSecurity',
        defaultMessage: 'Log in and security',
        description: 'Log in and security',
    },
    personalData: {
        id: 'menu.personalData',
        defaultMessage: 'Personal data',
        description: 'Personal data',
    },
    partShop: {
        id: 'menu.partShop',
        defaultMessage: 'Part Shop',
        description: 'Part Shop',
    },
    newMachine: {
        id: 'menu.newMachine',
        defaultMessage: 'Configure a New Machine',
        description: 'New Machine',
    },
    expandSidebar: {
        id: 'menu.expandSidebar',
        defaultMessage: 'Expand sidebar',
        description: 'Expand sidebar',
    },
    collapseSidebar: {
        id: 'menu.collapseSidebar',
        defaultMessage: 'Collapse sidebar',
        description: 'Collapse sidebar',
    },
});
exports.default = messages;
